import store from '@/store'
import { StatusUtil } from '@/utils/Status'
import { PersonHelper } from '@/helpers/Person'
import { CollectiveHelper } from '@/helpers/Collective'

export const StatusHelper = {
  ...StatusUtil,

  // returns true, if there are any product selected
  basketHasProducts(persons) {
    if (persons.length === 0) return false

    return persons.some(person => {
      const selectedProducts = getSelectedProductsOfPerson(person.personId)
      return selectedProducts.length > 0
    })
  },
  // returns false, if there are no persons, or none of the persons has a product selected
  basketIsComplete(basket) {
    const persons = PersonHelper.getPersonsToValidate(basket)
    if (persons.length === 0) return false
    let valid = true

    persons.forEach(person => {
      const selectedProducts = getSelectedProductsOfPerson(person.personId)

      if (selectedProducts.length === 0) {
        valid = false
      }
    })

    return valid
  },
  // returns false, if there are no persons, or any person doesn't have a product selected
  basketIsValid(basket, soft = true) {
    if (!basket.persons || basket.persons.length === 0) return false
    const personsToValidate = PersonHelper.getPersonsToValidate(basket)
    if (!StatusUtil.isPersonalDataValid(personsToValidate)) return false

    let valid = true

    personsToValidate.forEach(person => {
      const selectedProducts = getSelectedProductsOfPerson(person.personId)

      if (
        (soft && selectedProducts.length > 0 && selectedProducts.filter(p => !p.valid).length > 0) ||
        (!soft && selectedProducts.filter(p => p.valid).length === 0)
      ) {
        valid = false
      }
    })

    return valid
  },

  offerComplete(basket, persons) {
    const selectedCategoriesMap = PersonHelper.getSelectedCategoriesMap(persons)
    const isPersonnelNumberRequired = CollectiveHelper.isPersonnelNumberRequired()

    return (
      StatusUtil.isAdminDataComplete(basket, isPersonnelNumberRequired) &&
      this.basketIsComplete(basket) &&
      StatusUtil.isHealthQuestionsComplete(persons) &&
      StatusUtil.isOnboardingSecured(basket) &&
      StatusUtil.isPersonDataComplete(basket, selectedCategoriesMap)
    )
  },
  offerValid(basket, persons) {
    return this.basketIsValid(basket) && this.offerComplete(basket, persons) && StatusUtil.isPersonalDataValid(persons)
  },

  states(basket) {
    const { persons } = basket
    const selectedCategoriesMap = PersonHelper.getSelectedCategoriesMap(persons)
    const isPersonnelNumberRequired = CollectiveHelper.isPersonnelNumberRequired()
    return {
      isAdminDataComplete: StatusUtil.isAdminDataComplete(basket, isPersonnelNumberRequired),
      hasProducts: StatusHelper.basketHasProducts(persons),
      isBasketValid: StatusHelper.basketIsValid(basket),
      isEntryPersonsValid: StatusUtil.isPersonalDataValid(persons),
      areHealthQuestionsCompletedForAllPersons: StatusUtil.isHealthQuestionsComplete(persons),
      isOfferComplete: StatusHelper.offerComplete(basket, persons),
      isOfferValid: StatusHelper.offerValid(basket, persons),
      isOnboardingSecured: StatusUtil.isOnboardingSecured(basket),
      isPersonDataComplete: StatusUtil.isPersonDataComplete(basket, selectedCategoriesMap),
    }
  },
}

function getSelectedProductsOfPerson(personId) {
  return store.getters['basket/getSelectedProductsOfPerson'](personId)
}
